import React, { useMemo } from 'react';
import { Trans } from '@lingui/macro';
import { Box, Flex, Text } from '~/design-system';
import { getActiveDescriptors } from '../../descriptors';

type IntentChipsProps = {
  onPick: (text: string) => void;
};

const MAX_CHIPS = 7;

export default function IntentChips({ onPick }: IntentChipsProps) {
  const chips = useMemo(() => {
    const active = getActiveDescriptors();
    const result: {
      label: string;
      descriptorId: string;
      icon: React.ComponentType<any>;
    }[] = [];
    for (const d of active) {
      if (!d.intents.length) continue;
      result.push({
        label: d.intents[0],
        descriptorId: d.id,
        icon: d.icon as unknown as React.ComponentType<any>,
      });
      if (result.length >= MAX_CHIPS) break;
    }
    return result;
  }, []);

  if (!chips.length) return null;

  return (
    <Flex sx={{ alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <Text sx={{ fontSize: '12px', color: '#6b7280', marginRight: 1 }}>
        <Trans>Try:</Trans>
      </Text>
      {chips.map(({ label, descriptorId, icon: Icon }) => (
        // @ts-ignore — Box typing doesn't surface button-element props
        <Box
          key={descriptorId}
          as="button"
          type="button"
          onClick={() => onPick(label)}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            padding: '6px 12px',
            borderRadius: 999,
            border: '1px solid #e5e7eb',
            backgroundColor: 'white',
            fontSize: '13px',
            color: '#374151',
            cursor: 'pointer',
            transition: 'border-color 120ms ease, background-color 120ms ease',
            '&:hover': {
              borderColor: '#cbd5e1',
              backgroundColor: '#f9fafb',
            },
          }}
        >
          <Icon size={14} stroke={1.75} />
          {label}
        </Box>
      ))}
    </Flex>
  );
}
